// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as R500RouteImport } from './routes/500'
import { Route as HomeRouteImport } from './routes/_home'
import { Route as AboutRouteImport } from './routes/about'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as HomeIndexRouteImport } from './routes/_home/index'
import { Route as HomeAccountDeletedRouteImport } from './routes/_home/account-deleted'
import { Route as HomeAgentsRouteImport } from './routes/_home/agents'
import { Route as HomeAiBloggingPlatformRouteImport } from './routes/_home/ai-blogging-platform'
import { Route as HomeCompareRouteImport } from './routes/_home/compare'
import { Route as HomeFaqRouteImport } from './routes/_home/faq'
import { Route as HomeLinkedinCallbackRouteImport } from './routes/_home/linkedin-callback'
import { Route as HomeLoginRouteImport } from './routes/_home/login'
import { Route as HomePlatformRouteImport } from './routes/_home/platform'
import { Route as HomePricingRouteImport } from './routes/_home/pricing'
import { Route as HomePrivacyRouteImport } from './routes/_home/privacy'
import { Route as HomeTeamLoginRouteImport } from './routes/_home/team-login'
import { Route as HomeTermsRouteImport } from './routes/_home/terms'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as PreviewPostIdRouteImport } from './routes/preview.$postId'
import { Route as HomeApproveLinkHashRouteImport } from './routes/_home.approve-link.$hash'
import { Route as HomeApproveHashRouteImport } from './routes/_home.approve.$hash'
import { Route as HomeWaitlistJoinedRouteImport } from './routes/_home.waitlist.joined'
import { Route as BlogCategoriesIndexRouteImport } from './routes/blog/categories/index'
import { Route as BlogCategoriesCategoryRouteImport } from './routes/blog/categories/$category'
import { Route as BlogTagsIndexRouteImport } from './routes/blog/tags/index'
import { Route as BlogTagsTagRouteImport } from './routes/blog/tags/$tag'
import { Route as DashboardDomainsCloudflareCallbackRouteImport } from './routes/dashboard/domains_.cloudflare-callback'
import { Route as DashboardIntegrationsLinkedinCallbackRouteImport } from './routes/dashboard/integrations_.linkedin-callback'
import { Route as DashboardIntegrationsXCallbackRouteImport } from './routes/dashboard/integrations_.x-callback'
import { Route as DashboardWWorkspaceIdRouteImport } from './routes/dashboard/w/$workspaceId'
import { Route as OnboardingWorkspaceIdDesignRouteImport } from './routes/onboarding.$workspaceId.design'
import { Route as OnboardingWorkspaceIdDomainRouteImport } from './routes/onboarding.$workspaceId.domain'
import { Route as OnboardingWorkspaceIdFirstPostRouteImport } from './routes/onboarding.$workspaceId.first-post'
import { Route as OnboardingWorkspaceIdNameRouteImport } from './routes/onboarding.$workspaceId.name'
import { Route as OnboardingWorkspaceIdPurposeRouteImport } from './routes/onboarding.$workspaceId.purpose'
import { Route as OnboardingWorkspaceIdUpdatesRouteImport } from './routes/onboarding.$workspaceId.updates'
import { Route as PreviewWorkspaceIdPostIdRouteImport } from './routes/preview.$workspaceId.$postId'
import { Route as DashboardWWorkspaceIdIndexRouteImport } from './routes/dashboard/w/$workspaceId/index'
import { Route as DashboardWWorkspaceIdAnalyticsRouteImport } from './routes/dashboard/w/$workspaceId/analytics'
import { Route as DashboardWWorkspaceIdApiKeysRouteImport } from './routes/dashboard/w/$workspaceId/api-keys'
import { Route as DashboardWWorkspaceIdBouncesRouteImport } from './routes/dashboard/w/$workspaceId/bounces'
import { Route as DashboardWWorkspaceIdConfigurationRouteImport } from './routes/dashboard/w/$workspaceId/configuration'
import { Route as DashboardWWorkspaceIdDesignRouteImport } from './routes/dashboard/w/$workspaceId/design'
import { Route as DashboardWWorkspaceIdDeveloperRouteImport } from './routes/dashboard/w/$workspaceId/developer'
import { Route as DashboardWWorkspaceIdDomainsRouteImport } from './routes/dashboard/w/$workspaceId/domains'
import { Route as DashboardWWorkspaceIdEmailsRouteImport } from './routes/dashboard/w/$workspaceId/emails'
import { Route as DashboardWWorkspaceIdEventsRouteImport } from './routes/dashboard/w/$workspaceId/events'
import { Route as DashboardWWorkspaceIdIntegrationsRouteImport } from './routes/dashboard/w/$workspaceId/integrations'
import { Route as DashboardWWorkspaceIdNewsletterRouteImport } from './routes/dashboard/w/$workspaceId/newsletter'
import { Route as DashboardWWorkspaceIdPostsRouteImport } from './routes/dashboard/w/$workspaceId/posts'
import { Route as DashboardWWorkspaceIdPublishRouteImport } from './routes/dashboard/w/$workspaceId/publish'
import { Route as DashboardWWorkspaceIdSendingRouteImport } from './routes/dashboard/w/$workspaceId/sending'
import { Route as DashboardWWorkspaceIdSettingsRouteImport } from './routes/dashboard/w/$workspaceId/settings'
import { Route as DashboardWWorkspaceIdSubscribersRouteImport } from './routes/dashboard/w/$workspaceId/subscribers'
import { Route as DashboardWWorkspaceIdTemplatesRouteImport } from './routes/dashboard/w/$workspaceId/templates'
import { Route as DashboardWWorkspaceIdDeveloperIndexRouteImport } from './routes/dashboard/w/$workspaceId/developer/index'
import { Route as DashboardWWorkspaceIdDeveloperAccessRouteImport } from './routes/dashboard/w/$workspaceId/developer/access'
import { Route as DashboardWWorkspaceIdDeveloperEmailRouteImport } from './routes/dashboard/w/$workspaceId/developer/email'
import { Route as DashboardWWorkspaceIdDeveloperMcpRouteImport } from './routes/dashboard/w/$workspaceId/developer/mcp'
import { Route as DashboardWWorkspaceIdDeveloperWebhookRouteImport } from './routes/dashboard/w/$workspaceId/developer/webhook'
import { Route as DashboardWWorkspaceIdIntegrationsIndexRouteImport } from './routes/dashboard/w/$workspaceId/integrations/index'
import { Route as DashboardWWorkspaceIdIntegrationsNewsletterRouteImport } from './routes/dashboard/w/$workspaceId/integrations/newsletter'
import { Route as DashboardWWorkspaceIdPostsIndexRouteImport } from './routes/dashboard/w/$workspaceId/posts/index'
import { Route as DashboardWWorkspaceIdPostsPostIdRouteImport } from './routes/dashboard/w/$workspaceId/posts/$postId'
import { Route as DashboardWWorkspaceIdPostsNewRouteImport } from './routes/dashboard/w/$workspaceId/posts/new'
import { Route as DashboardWWorkspaceIdSendingIndexRouteImport } from './routes/dashboard/w/$workspaceId/sending/index'
import { Route as DashboardWWorkspaceIdSendingApiKeysRouteImport } from './routes/dashboard/w/$workspaceId/sending/api-keys'
import { Route as DashboardWWorkspaceIdSendingBouncesRouteImport } from './routes/dashboard/w/$workspaceId/sending/bounces'
import { Route as DashboardWWorkspaceIdSendingDomainsRouteImport } from './routes/dashboard/w/$workspaceId/sending/domains'
import { Route as DashboardWWorkspaceIdSendingEventsRouteImport } from './routes/dashboard/w/$workspaceId/sending/events'
import { Route as DashboardWWorkspaceIdSendingTemplatesRouteImport } from './routes/dashboard/w/$workspaceId/sending/templates'
import { Route as DashboardWWorkspaceIdSubscribersIndexRouteImport } from './routes/dashboard/w/$workspaceId/subscribers/index'
import { Route as DashboardWWorkspaceIdSubscribersDomainEmailRouteImport } from './routes/dashboard/w/$workspaceId/subscribers/$domain/$email'

const R404Route = R404RouteImport.update({
            id: '/404',path: '/404',getParentRoute: () => rootRouteImport
          })
const R500Route = R500RouteImport.update({
            id: '/500',path: '/500',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/_home',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => rootRouteImport
          })
const HomeIndexRoute = HomeIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HomeRoute
          })
const HomeAccountDeletedRoute = HomeAccountDeletedRouteImport.update({
            id: '/account-deleted',path: '/account-deleted',getParentRoute: () => HomeRoute
          })
const HomeAgentsRoute = HomeAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => HomeRoute
          })
const HomeAiBloggingPlatformRoute = HomeAiBloggingPlatformRouteImport.update({
            id: '/ai-blogging-platform',path: '/ai-blogging-platform',getParentRoute: () => HomeRoute
          })
const HomeCompareRoute = HomeCompareRouteImport.update({
            id: '/compare',path: '/compare',getParentRoute: () => HomeRoute
          })
const HomeFaqRoute = HomeFaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => HomeRoute
          })
const HomeLinkedinCallbackRoute = HomeLinkedinCallbackRouteImport.update({
            id: '/linkedin-callback',path: '/linkedin-callback',getParentRoute: () => HomeRoute
          })
const HomeLoginRoute = HomeLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => HomeRoute
          })
const HomePlatformRoute = HomePlatformRouteImport.update({
            id: '/platform',path: '/platform',getParentRoute: () => HomeRoute
          })
const HomePricingRoute = HomePricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => HomeRoute
          })
const HomePrivacyRoute = HomePrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => HomeRoute
          })
const HomeTeamLoginRoute = HomeTeamLoginRouteImport.update({
            id: '/team-login',path: '/team-login',getParentRoute: () => HomeRoute
          })
const HomeTermsRoute = HomeTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => HomeRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const DashboardIndexRoute = DashboardIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardRoute
          })
const PreviewPostIdRoute = PreviewPostIdRouteImport.update({
            id: '/preview/$postId',path: '/preview/$postId',getParentRoute: () => rootRouteImport
          })
const HomeApproveLinkHashRoute = HomeApproveLinkHashRouteImport.update({
            id: '/approve-link/$hash',path: '/approve-link/$hash',getParentRoute: () => HomeRoute
          })
const HomeApproveHashRoute = HomeApproveHashRouteImport.update({
            id: '/approve/$hash',path: '/approve/$hash',getParentRoute: () => HomeRoute
          })
const HomeWaitlistJoinedRoute = HomeWaitlistJoinedRouteImport.update({
            id: '/waitlist/joined',path: '/waitlist/joined',getParentRoute: () => HomeRoute
          })
const BlogCategoriesIndexRoute = BlogCategoriesIndexRouteImport.update({
            id: '/blog/categories/',path: '/blog/categories/',getParentRoute: () => rootRouteImport
          })
const BlogCategoriesCategoryRoute = BlogCategoriesCategoryRouteImport.update({
            id: '/blog/categories/$category',path: '/blog/categories/$category',getParentRoute: () => rootRouteImport
          })
const BlogTagsIndexRoute = BlogTagsIndexRouteImport.update({
            id: '/blog/tags/',path: '/blog/tags/',getParentRoute: () => rootRouteImport
          })
const BlogTagsTagRoute = BlogTagsTagRouteImport.update({
            id: '/blog/tags/$tag',path: '/blog/tags/$tag',getParentRoute: () => rootRouteImport
          })
const DashboardDomainsCloudflareCallbackRoute = DashboardDomainsCloudflareCallbackRouteImport.update({
            id: '/domains_/cloudflare-callback',path: '/domains/cloudflare-callback',getParentRoute: () => DashboardRoute
          })
const DashboardIntegrationsLinkedinCallbackRoute = DashboardIntegrationsLinkedinCallbackRouteImport.update({
            id: '/integrations_/linkedin-callback',path: '/integrations/linkedin-callback',getParentRoute: () => DashboardRoute
          })
const DashboardIntegrationsXCallbackRoute = DashboardIntegrationsXCallbackRouteImport.update({
            id: '/integrations_/x-callback',path: '/integrations/x-callback',getParentRoute: () => DashboardRoute
          })
const DashboardWWorkspaceIdRoute = DashboardWWorkspaceIdRouteImport.update({
            id: '/w/$workspaceId',path: '/w/$workspaceId',getParentRoute: () => DashboardRoute
          })
const OnboardingWorkspaceIdDesignRoute = OnboardingWorkspaceIdDesignRouteImport.update({
            id: '/onboarding/$workspaceId/design',path: '/onboarding/$workspaceId/design',getParentRoute: () => rootRouteImport
          })
const OnboardingWorkspaceIdDomainRoute = OnboardingWorkspaceIdDomainRouteImport.update({
            id: '/onboarding/$workspaceId/domain',path: '/onboarding/$workspaceId/domain',getParentRoute: () => rootRouteImport
          })
const OnboardingWorkspaceIdFirstPostRoute = OnboardingWorkspaceIdFirstPostRouteImport.update({
            id: '/onboarding/$workspaceId/first-post',path: '/onboarding/$workspaceId/first-post',getParentRoute: () => rootRouteImport
          })
const OnboardingWorkspaceIdNameRoute = OnboardingWorkspaceIdNameRouteImport.update({
            id: '/onboarding/$workspaceId/name',path: '/onboarding/$workspaceId/name',getParentRoute: () => rootRouteImport
          })
const OnboardingWorkspaceIdPurposeRoute = OnboardingWorkspaceIdPurposeRouteImport.update({
            id: '/onboarding/$workspaceId/purpose',path: '/onboarding/$workspaceId/purpose',getParentRoute: () => rootRouteImport
          })
const OnboardingWorkspaceIdUpdatesRoute = OnboardingWorkspaceIdUpdatesRouteImport.update({
            id: '/onboarding/$workspaceId/updates',path: '/onboarding/$workspaceId/updates',getParentRoute: () => rootRouteImport
          })
const PreviewWorkspaceIdPostIdRoute = PreviewWorkspaceIdPostIdRouteImport.update({
            id: '/preview/$workspaceId/$postId',path: '/preview/$workspaceId/$postId',getParentRoute: () => rootRouteImport
          })
const DashboardWWorkspaceIdIndexRoute = DashboardWWorkspaceIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdAnalyticsRoute = DashboardWWorkspaceIdAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdApiKeysRoute = DashboardWWorkspaceIdApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdBouncesRoute = DashboardWWorkspaceIdBouncesRouteImport.update({
            id: '/bounces',path: '/bounces',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdConfigurationRoute = DashboardWWorkspaceIdConfigurationRouteImport.update({
            id: '/configuration',path: '/configuration',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdDesignRoute = DashboardWWorkspaceIdDesignRouteImport.update({
            id: '/design',path: '/design',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdDeveloperRoute = DashboardWWorkspaceIdDeveloperRouteImport.update({
            id: '/developer',path: '/developer',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdDomainsRoute = DashboardWWorkspaceIdDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdEmailsRoute = DashboardWWorkspaceIdEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdEventsRoute = DashboardWWorkspaceIdEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdIntegrationsRoute = DashboardWWorkspaceIdIntegrationsRouteImport.update({
            id: '/integrations',path: '/integrations',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdNewsletterRoute = DashboardWWorkspaceIdNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdPostsRoute = DashboardWWorkspaceIdPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdPublishRoute = DashboardWWorkspaceIdPublishRouteImport.update({
            id: '/publish',path: '/publish',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdSendingRoute = DashboardWWorkspaceIdSendingRouteImport.update({
            id: '/sending',path: '/sending',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdSettingsRoute = DashboardWWorkspaceIdSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdSubscribersRoute = DashboardWWorkspaceIdSubscribersRouteImport.update({
            id: '/subscribers',path: '/subscribers',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdTemplatesRoute = DashboardWWorkspaceIdTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => DashboardWWorkspaceIdRoute
          })
const DashboardWWorkspaceIdDeveloperIndexRoute = DashboardWWorkspaceIdDeveloperIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdDeveloperRoute
          })
const DashboardWWorkspaceIdDeveloperAccessRoute = DashboardWWorkspaceIdDeveloperAccessRouteImport.update({
            id: '/access',path: '/access',getParentRoute: () => DashboardWWorkspaceIdDeveloperRoute
          })
const DashboardWWorkspaceIdDeveloperEmailRoute = DashboardWWorkspaceIdDeveloperEmailRouteImport.update({
            id: '/email',path: '/email',getParentRoute: () => DashboardWWorkspaceIdDeveloperRoute
          })
const DashboardWWorkspaceIdDeveloperMcpRoute = DashboardWWorkspaceIdDeveloperMcpRouteImport.update({
            id: '/mcp',path: '/mcp',getParentRoute: () => DashboardWWorkspaceIdDeveloperRoute
          })
const DashboardWWorkspaceIdDeveloperWebhookRoute = DashboardWWorkspaceIdDeveloperWebhookRouteImport.update({
            id: '/webhook',path: '/webhook',getParentRoute: () => DashboardWWorkspaceIdDeveloperRoute
          })
const DashboardWWorkspaceIdIntegrationsIndexRoute = DashboardWWorkspaceIdIntegrationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdIntegrationsRoute
          })
const DashboardWWorkspaceIdIntegrationsNewsletterRoute = DashboardWWorkspaceIdIntegrationsNewsletterRouteImport.update({
            id: '/newsletter',path: '/newsletter',getParentRoute: () => DashboardWWorkspaceIdIntegrationsRoute
          })
const DashboardWWorkspaceIdPostsIndexRoute = DashboardWWorkspaceIdPostsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdPostsRoute
          })
const DashboardWWorkspaceIdPostsPostIdRoute = DashboardWWorkspaceIdPostsPostIdRouteImport.update({
            id: '/$postId',path: '/$postId',getParentRoute: () => DashboardWWorkspaceIdPostsRoute
          })
const DashboardWWorkspaceIdPostsNewRoute = DashboardWWorkspaceIdPostsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => DashboardWWorkspaceIdPostsRoute
          })
const DashboardWWorkspaceIdSendingIndexRoute = DashboardWWorkspaceIdSendingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSendingApiKeysRoute = DashboardWWorkspaceIdSendingApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSendingBouncesRoute = DashboardWWorkspaceIdSendingBouncesRouteImport.update({
            id: '/bounces',path: '/bounces',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSendingDomainsRoute = DashboardWWorkspaceIdSendingDomainsRouteImport.update({
            id: '/domains',path: '/domains',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSendingEventsRoute = DashboardWWorkspaceIdSendingEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSendingTemplatesRoute = DashboardWWorkspaceIdSendingTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => DashboardWWorkspaceIdSendingRoute
          })
const DashboardWWorkspaceIdSubscribersIndexRoute = DashboardWWorkspaceIdSubscribersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardWWorkspaceIdSubscribersRoute
          })
const DashboardWWorkspaceIdSubscribersDomainEmailRoute = DashboardWWorkspaceIdSubscribersDomainEmailRouteImport.update({
            id: '/$domain/$email',path: '/$domain/$email',getParentRoute: () => DashboardWWorkspaceIdSubscribersRoute
          })





const HomeRouteChildren = {
  HomeAccountDeletedRoute: HomeAccountDeletedRoute,HomeAgentsRoute: HomeAgentsRoute,HomeAiBloggingPlatformRoute: HomeAiBloggingPlatformRoute,HomeCompareRoute: HomeCompareRoute,HomeFaqRoute: HomeFaqRoute,HomeLinkedinCallbackRoute: HomeLinkedinCallbackRoute,HomeLoginRoute: HomeLoginRoute,HomePlatformRoute: HomePlatformRoute,HomePricingRoute: HomePricingRoute,HomePrivacyRoute: HomePrivacyRoute,HomeTeamLoginRoute: HomeTeamLoginRoute,HomeTermsRoute: HomeTermsRoute,HomeIndexRoute: HomeIndexRoute,HomeApproveLinkHashRoute: HomeApproveLinkHashRoute,HomeApproveHashRoute: HomeApproveHashRoute,HomeWaitlistJoinedRoute: HomeWaitlistJoinedRoute
}

const HomeRouteWithChildren = HomeRoute._addFileChildren(HomeRouteChildren)




const DashboardWWorkspaceIdDeveloperRouteChildren = {
  DashboardWWorkspaceIdDeveloperAccessRoute: DashboardWWorkspaceIdDeveloperAccessRoute,DashboardWWorkspaceIdDeveloperEmailRoute: DashboardWWorkspaceIdDeveloperEmailRoute,DashboardWWorkspaceIdDeveloperMcpRoute: DashboardWWorkspaceIdDeveloperMcpRoute,DashboardWWorkspaceIdDeveloperWebhookRoute: DashboardWWorkspaceIdDeveloperWebhookRoute,DashboardWWorkspaceIdDeveloperIndexRoute: DashboardWWorkspaceIdDeveloperIndexRoute
}

const DashboardWWorkspaceIdDeveloperRouteWithChildren = DashboardWWorkspaceIdDeveloperRoute._addFileChildren(DashboardWWorkspaceIdDeveloperRouteChildren)




const DashboardWWorkspaceIdIntegrationsRouteChildren = {
  DashboardWWorkspaceIdIntegrationsNewsletterRoute: DashboardWWorkspaceIdIntegrationsNewsletterRoute,DashboardWWorkspaceIdIntegrationsIndexRoute: DashboardWWorkspaceIdIntegrationsIndexRoute
}

const DashboardWWorkspaceIdIntegrationsRouteWithChildren = DashboardWWorkspaceIdIntegrationsRoute._addFileChildren(DashboardWWorkspaceIdIntegrationsRouteChildren)




const DashboardWWorkspaceIdPostsRouteChildren = {
  DashboardWWorkspaceIdPostsPostIdRoute: DashboardWWorkspaceIdPostsPostIdRoute,DashboardWWorkspaceIdPostsNewRoute: DashboardWWorkspaceIdPostsNewRoute,DashboardWWorkspaceIdPostsIndexRoute: DashboardWWorkspaceIdPostsIndexRoute
}

const DashboardWWorkspaceIdPostsRouteWithChildren = DashboardWWorkspaceIdPostsRoute._addFileChildren(DashboardWWorkspaceIdPostsRouteChildren)




const DashboardWWorkspaceIdSendingRouteChildren = {
  DashboardWWorkspaceIdSendingApiKeysRoute: DashboardWWorkspaceIdSendingApiKeysRoute,DashboardWWorkspaceIdSendingBouncesRoute: DashboardWWorkspaceIdSendingBouncesRoute,DashboardWWorkspaceIdSendingDomainsRoute: DashboardWWorkspaceIdSendingDomainsRoute,DashboardWWorkspaceIdSendingEventsRoute: DashboardWWorkspaceIdSendingEventsRoute,DashboardWWorkspaceIdSendingTemplatesRoute: DashboardWWorkspaceIdSendingTemplatesRoute,DashboardWWorkspaceIdSendingIndexRoute: DashboardWWorkspaceIdSendingIndexRoute
}

const DashboardWWorkspaceIdSendingRouteWithChildren = DashboardWWorkspaceIdSendingRoute._addFileChildren(DashboardWWorkspaceIdSendingRouteChildren)




const DashboardWWorkspaceIdSubscribersRouteChildren = {
  DashboardWWorkspaceIdSubscribersIndexRoute: DashboardWWorkspaceIdSubscribersIndexRoute,DashboardWWorkspaceIdSubscribersDomainEmailRoute: DashboardWWorkspaceIdSubscribersDomainEmailRoute
}

const DashboardWWorkspaceIdSubscribersRouteWithChildren = DashboardWWorkspaceIdSubscribersRoute._addFileChildren(DashboardWWorkspaceIdSubscribersRouteChildren)



const DashboardWWorkspaceIdRouteChildren = {
  DashboardWWorkspaceIdAnalyticsRoute: DashboardWWorkspaceIdAnalyticsRoute,DashboardWWorkspaceIdApiKeysRoute: DashboardWWorkspaceIdApiKeysRoute,DashboardWWorkspaceIdBouncesRoute: DashboardWWorkspaceIdBouncesRoute,DashboardWWorkspaceIdConfigurationRoute: DashboardWWorkspaceIdConfigurationRoute,DashboardWWorkspaceIdDesignRoute: DashboardWWorkspaceIdDesignRoute,DashboardWWorkspaceIdDeveloperRoute: DashboardWWorkspaceIdDeveloperRouteWithChildren,DashboardWWorkspaceIdDomainsRoute: DashboardWWorkspaceIdDomainsRoute,DashboardWWorkspaceIdEmailsRoute: DashboardWWorkspaceIdEmailsRoute,DashboardWWorkspaceIdEventsRoute: DashboardWWorkspaceIdEventsRoute,DashboardWWorkspaceIdIntegrationsRoute: DashboardWWorkspaceIdIntegrationsRouteWithChildren,DashboardWWorkspaceIdNewsletterRoute: DashboardWWorkspaceIdNewsletterRoute,DashboardWWorkspaceIdPostsRoute: DashboardWWorkspaceIdPostsRouteWithChildren,DashboardWWorkspaceIdPublishRoute: DashboardWWorkspaceIdPublishRoute,DashboardWWorkspaceIdSendingRoute: DashboardWWorkspaceIdSendingRouteWithChildren,DashboardWWorkspaceIdSettingsRoute: DashboardWWorkspaceIdSettingsRoute,DashboardWWorkspaceIdSubscribersRoute: DashboardWWorkspaceIdSubscribersRouteWithChildren,DashboardWWorkspaceIdTemplatesRoute: DashboardWWorkspaceIdTemplatesRoute,DashboardWWorkspaceIdIndexRoute: DashboardWWorkspaceIdIndexRoute
}

const DashboardWWorkspaceIdRouteWithChildren = DashboardWWorkspaceIdRoute._addFileChildren(DashboardWWorkspaceIdRouteChildren)



const DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,DashboardDomainsCloudflareCallbackRoute: DashboardDomainsCloudflareCallbackRoute,DashboardIntegrationsLinkedinCallbackRoute: DashboardIntegrationsLinkedinCallbackRoute,DashboardIntegrationsXCallbackRoute: DashboardIntegrationsXCallbackRoute,DashboardWWorkspaceIdRoute: DashboardWWorkspaceIdRouteWithChildren
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  R404Route: R404Route,R500Route: R500Route,HomeRoute: HomeRouteWithChildren,AboutRoute: AboutRoute,DashboardRoute: DashboardRouteWithChildren,BlogSlugRoute: BlogSlugRoute,PreviewPostIdRoute: PreviewPostIdRoute,BlogIndexRoute: BlogIndexRoute,BlogCategoriesCategoryRoute: BlogCategoriesCategoryRoute,BlogTagsTagRoute: BlogTagsTagRoute,OnboardingWorkspaceIdDesignRoute: OnboardingWorkspaceIdDesignRoute,OnboardingWorkspaceIdDomainRoute: OnboardingWorkspaceIdDomainRoute,OnboardingWorkspaceIdFirstPostRoute: OnboardingWorkspaceIdFirstPostRoute,OnboardingWorkspaceIdNameRoute: OnboardingWorkspaceIdNameRoute,OnboardingWorkspaceIdPurposeRoute: OnboardingWorkspaceIdPurposeRoute,OnboardingWorkspaceIdUpdatesRoute: OnboardingWorkspaceIdUpdatesRoute,PreviewWorkspaceIdPostIdRoute: PreviewWorkspaceIdPostIdRoute,BlogCategoriesIndexRoute: BlogCategoriesIndexRoute,BlogTagsIndexRoute: BlogTagsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)